import { FaInstagram, FaTiktok } from 'react-icons/fa6'
import { FiGlobe } from 'react-icons/fi'
import { useTranslation } from '../i18n/LanguageContext'
import { useMobile } from '../hooks/useMobile'

export default function Footer() {
  const { t } = useTranslation()
  const isMobile = useMobile()

  return (
    <footer style={styles.footer}>
      <p style={styles.copyright}>{t.app.footer}</p>
      <div style={{ ...styles.links, flexDirection: isMobile ? 'column' : 'row' }}>
        <a
          href="https://tengodeto.net"
          target="_blank"
          rel="noopener noreferrer"
          style={styles.link}
        >
          <FiGlobe size={14} />
          tengodeto.net
        </a>
        <a
          href="https://instagram.com/tengode_to"
          target="_blank"
          rel="noopener noreferrer"
          style={styles.link}
        >
          <FaInstagram size={14} />
          @tengode_to
        </a>
        <a
          href="https://tiktok.com/@tengode_to"
          target="_blank"
          rel="noopener noreferrer"
          style={styles.link}
        >
          <FaTiktok size={14} />
          @tengode_to
        </a>
      </div>
    </footer>
  )
}

const styles: Record<string, React.CSSProperties> = {
  footer: {
    borderTop:      '1px solid #EFE7D7',
    background:     '#FAF6EF',
    padding:        '16px 24px',
    display:        'flex',
    flexWrap:       'wrap' as const,
    alignItems:     'center',
    justifyContent: 'center',
    gap:            12,
  },
  copyright: {
    fontSize: '0.875rem',
    color:       '#9A8070',
    fontWeight:  500,
    letterSpacing: '0.04em',
    margin:      0,
  },
  links: {
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center',
    gap:            16,
    flexWrap:       'wrap' as const,
  },
  link: {
    display:        'flex',
    alignItems:     'center',
    gap:            5,
    fontSize: '0.875rem',
    color:          '#9A8070',
    fontWeight:     500,
    textDecoration: 'none',
    letterSpacing:  '0.02em',
    transition:     'color 0.15s ease',
  },
}
